import React from "react"

const LEGAL_UPDATED_AT = "2026-06-25"

const privacySections = [
  {
    title: "개인정보 처리 목적",
    body: [
      "CodeGrove는 홈페이지 문의 응대, 교육 및 개발 프로젝트 상담, 내부 강의 콘텐츠 게시 업무를 위해 필요한 최소한의 정보를 처리합니다.",
      "YouTube Data API는 CodeGrove가 권한을 가진 YouTube 채널에 강의 영상을 업로드하고, 제목, 설명, 자막, 썸네일, 재생목록을 관리하기 위한 내부 업무에만 사용됩니다.",
    ],
  },
  {
    title: "처리하는 정보",
    body: [
      "홈페이지 문의 시 이름, 이메일 주소, 문의 내용이 처리될 수 있습니다.",
      "YouTube API 사용 시 업로드 상태, 영상 ID, 재생목록 ID, 자막 ID, 썸네일 처리 상태, 영상 제목과 설명 등 콘텐츠 게시에 필요한 정보가 처리될 수 있습니다.",
      "OAuth 토큰과 인증 정보는 공개 저장소에 보관하지 않으며, 운영에 필요한 범위에서만 관리합니다.",
    ],
  },
  {
    title: "공유 및 보관",
    body: [
      "CodeGrove는 YouTube API 데이터를 광고, 판매, 데이터 중개 목적으로 제공하지 않습니다.",
      "문의 정보와 업로드 작업 기록은 업무 처리, 장애 대응, 감사 추적에 필요한 기간 동안만 보관합니다.",
    ],
  },
  {
    title: "삭제 및 접근 철회",
    body: [
      "개인정보 삭제 또는 YouTube API 관련 로컬 작업 기록 삭제가 필요한 경우 아래 연락처로 요청할 수 있습니다.",
      "Google 계정 권한 페이지에서 CodeGrove 도구의 YouTube 접근 권한을 직접 철회할 수 있습니다.",
    ],
  },
]

const termsSections = [
  {
    title: "서비스 범위",
    body: [
      "CodeGrove 홈페이지는 회사 소개, 교육 및 개발 서비스 안내, 문의 접수를 위한 공개 웹사이트입니다.",
      "CodeGrove Course Uploader는 CodeGrove가 권한을 가진 YouTube 채널의 강의 콘텐츠를 게시하고 관리하기 위한 내부 운영 도구입니다.",
    ],
  },
  {
    title: "허용되는 사용",
    body: [
      "CodeGrove가 제작하거나 게시 권한을 가진 강의 영상, 자막, 썸네일, 제목, 설명, 재생목록을 관리하는 목적으로만 사용합니다.",
      "YouTube API Services Terms of Service와 Google API Services User Data Policy를 준수합니다.",
    ],
  },
  {
    title: "제한 사항",
    body: [
      "명시적 권한이 없는 제3자 채널 관리, YouTube 데이터 스크래핑, 광고 목적 프로파일링, 데이터 판매 또는 재판매에 사용하지 않습니다.",
      "OAuth 토큰, 클라이언트 시크릿, API 키 등 인증 정보는 공개하거나 외부에 공유하지 않습니다.",
    ],
  },
  {
    title: "문의 및 접근 철회",
    body: [
      "서비스 이용, 데이터 삭제, API 접근 철회와 관련된 요청은 아래 연락처로 보낼 수 있습니다.",
      "Google 계정 권한 페이지에서 언제든지 YouTube 접근 권한을 철회할 수 있습니다.",
    ],
  },
]

const content = {
  privacy: {
    label: "Privacy Policy",
    title: "Privacy Policy",
    subtitle: "CodeGrove 개인정보 처리방침",
    intro:
      "이 방침은 CodeGrove 홈페이지와 CodeGrove의 내부 YouTube 강의 업로드 업무에서 처리되는 정보에 적용됩니다.",
    sections: privacySections,
  },
  terms: {
    label: "Terms of Service",
    title: "Terms of Service",
    subtitle: "CodeGrove 서비스 이용약관",
    intro:
      "이 약관은 CodeGrove 홈페이지와 CodeGrove 내부 강의 업로드 도구의 사용 기준을 간단히 설명합니다.",
    sections: termsSections,
  },
}

const LegalPage = ({ type }) => {
  const page = content[type] || content.privacy

  return (
    <main className="min-h-screen bg-white text-gray-800">
      <header className="border-b border-gray-200 bg-white">
        <div className="container mx-auto px-6 py-5 lg:px-8">
          <a href="/" className="inline-flex items-center gap-3">
            <img src="/web_logo.png" alt="Codegrove 로고" className="h-9 w-auto" />
            <span className="text-sm font-medium text-gray-500">CodeGrove</span>
          </a>
        </div>
      </header>

      <article className="container mx-auto max-w-3xl px-6 py-14 lg:px-8">
        <p className="text-sm font-medium text-green-700">{page.label}</p>
        <h1 className="mt-3 text-3xl font-semibold text-gray-900">{page.title}</h1>
        <p className="mt-2 text-lg text-gray-600">{page.subtitle}</p>
        <p className="mt-6 text-base leading-7 text-gray-700">{page.intro}</p>
        <p className="mt-4 text-sm text-gray-500">Last updated: {LEGAL_UPDATED_AT}</p>

        <div className="mt-10 space-y-9">
          {page.sections.map((section) => (
            <section key={section.title}>
              <h2 className="text-xl font-semibold text-gray-900">{section.title}</h2>
              <ul className="mt-4 space-y-3 text-base leading-7 text-gray-700">
                {section.body.map((item) => (
                  <li key={item} className="pl-4 before:mr-2 before:content-['-']">
                    {item}
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>

        <section className="mt-12 rounded border border-gray-200 bg-gray-50 p-5">
          <h2 className="text-base font-semibold text-gray-900">Contact</h2>
          <p className="mt-2 text-sm leading-6 text-gray-700">
            CodeGrove / 주식회사 코드그로브
            <br />
            Email:{" "}
            <a className="text-green-700 underline" href="mailto:jmbae@codegrove.co.kr">
              jmbae@codegrove.co.kr
            </a>
            <br />
            Google Privacy Policy:{" "}
            <a
              className="text-green-700 underline"
              href="https://policies.google.com/privacy"
              rel="noreferrer"
              target="_blank"
            >
              https://policies.google.com/privacy
            </a>
          </p>
        </section>
      </article>
    </main>
  )
}

export default LegalPage
